<div id="{{elementId}}"></div>
<i class="dark-body-toggle g-icon g-icon-planing pointer"
   *ngIf="toggleableDarkBody"
   (click)="toggleDarkBody()"></i>